//React
import React from 'react';
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Add
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';
//Material-ui
import Button from '@material-ui/core/Button';
//Part
import PartPersonalityTable from './PartPersonalityTable';
import PartPersonalityImage from './PartPersonalityImage';
import PartPersonalityElement from './PartPersonalityElement';
import PartPersonalityRelationTable from './PartPersonalityRelationTable';
import PartStarIcon from './PartStarIcon';

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pic: props.pic,
      type16: '',
      typeEI: 0,
      typeSN: 0,
      typeTF: 0,
      typeJP: 0,
      type: '',
      outline: '',
      element1: '',
      element2: '',
      element3: '',
      element4: '',
      element5: '',
      element6: '',
      element7: '',
      element8: '',
      relationsComment: '',
      lifeComment: '',
      jobComment: '',
      loveComment: '',
      relationSummary: '',
      relationStars: 0,
      relationComment: '',
      myElement: [],
      partnerElement: [],
  	}
  }

  componentDidMount() {
    this._personalityTypeGet();
  }

  _personalityTypeGet() {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('uic', this.state.pic);
    return axios.post(config.apiUri + "member/partnerPersonalityApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      this.setState({
        type16: res.data.type16,
        typeEI: res.data.typeEI,
        typeSN: res.data.typeSN,
        typeTF: res.data.typeTF,
        typeJP: res.data.typeJP,
        type: res.data.partnerPersonality.type,
        outline: res.data.partnerPersonality.type_outline,
        element1: res.data.partnerPersonality.type_element1,
        element2: res.data.partnerPersonality.type_element2,
        element3: res.data.partnerPersonality.type_element3,
        element4: res.data.partnerPersonality.type_element4,
        element5: res.data.partnerPersonality.type_element5,
        element6: res.data.partnerPersonality.type_element6,
        element7: res.data.partnerPersonality.type_element7,
        element8: res.data.partnerPersonality.type_element8,
        relationComment: res.data.partnerPersonality.type_relations,
        lifeComment: res.data.partnerPersonality.type_life,
        jobComment: res.data.partnerPersonality.type_job,
        loveComment: res.data.partnerPersonality.type_love,
        partnerElement: [
          res.data.partnerPersonality.type_element1,
          res.data.partnerPersonality.type_element2,
          res.data.partnerPersonality.type_element3,
          res.data.partnerPersonality.type_element4,
          res.data.partnerPersonality.type_element5,
          res.data.partnerPersonality.type_element6,
          res.data.partnerPersonality.type_element7,
          res.data.partnerPersonality.type_element8,
        ]
      });
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }


  _renderRelation() {
    let relation;
    let relationSummary;
    let relationComment;
    let relationStars;

    let index = this.props.my.personality.relation.findIndex((v) => v.type2 === this.state.type16);
		if (index >= 0) {
      relation = this.props.my.personality.relation[index].relation;
      relationSummary = this.props.my.personality.relation[index].relation_summary;
      relationStars = this.props.my.personality.relation[index].stars;
			relationComment = this.props.my.personality.relation[index].relation_comment;
      if (relation.match(/>/)) {
        relationComment = relationComment.replace(/MBTI1/g, 'あなた').replace(/MBTI2/g, 'パートナー');
      }
      else if (relation.match(/</)) {
        relationComment = relationComment.replace(/MBTI2/g, 'あなた').replace(/MBTI1/g, 'パートナー');
      }
		}

    return (
      <div>
        <h2 align='center'>
          {this.props.my.personality.type16+'と'+this.state.type16+'の関係'}
        </h2>


        <h3 align='center'>{relationSummary}</h3>
        <div align='center'>
          <PartStarIcon
            count={relationStars}
            style={{color:'#FFBC57'}}
          />
          <PartPersonalityRelationTable
            myType16={this.props.my.personality.type16}
            myElement={[
              this.props.my.personality.element1,
              this.props.my.personality.element2,
              this.props.my.personality.element3,
              this.props.my.personality.element4,
              this.props.my.personality.element5,
              this.props.my.personality.element6,
              this.props.my.personality.element7,
              this.props.my.personality.element8,
            ]}
            partnerType16={this.state.type16}
            partnerElement={this.state.partnerElement}
          />
        </div>
        <div style={{margin:'10px'}}>
          <h2>解説</h2>
          <div style={{whiteSpace: 'pre-line'}}>
            {relationComment}
          </div>
        </div>
      </div>
    )
  }

	render() {
    return (
      <div>
        <div style={{maxWidth:'600px', margin:'auto'}}>

          <h1 align='center'>{this.state.type16}タイプ</h1>
          <h2 align='center'>{this.state.type}</h2>
          <h3 align='center'>{this.state.outline}</h3>
          <div align='center'>
            <PartPersonalityImage
              type16={this.state.type16}
              width={300}
            />

          </div>
        </div>

        <div style={{maxWidth:'400px', margin:'auto'}}>
          <PartPersonalityTable
            type16={this.state.type16}
            countEI={this.state.typeEI}
            countSN={this.state.typeSN}
            countTF={this.state.typeTF}
            countJP={this.state.typeJP}
          />
          <PartPersonalityElement
            element1={this.state.element1}
            element2={this.state.element2}
            element3={this.state.element3}
            element4={this.state.element4}
            element5={this.state.element5}
            element6={this.state.element6}
            element7={this.state.element7}
            element8={this.state.element8}
          />


        </div>
        <div style={{maxWidth:'600px', margin:'auto'}}>
          <div style={{margin:'10px'}}>
            <h2>人間関係</h2>
            <div style={{whiteSpace: 'pre-line'}}>
              {this.state.relationComment}
            </div>
          </div>
          <div style={{margin:'10px'}}>
            <h2>生活</h2>
            <div style={{whiteSpace: 'pre-line'}}>
              {this.state.lifeComment}
            </div>
          </div>
          <div style={{margin:'10px'}}>
            <h2>仕事</h2>
            <div style={{whiteSpace: 'pre-line'}}>
              {this.state.jobComment}
            </div>
          </div>
          <div style={{margin:'10px'}}>
            <h2>恋愛</h2>
            <div style={{whiteSpace: 'pre-line'}}>
              {this.state.loveComment}
            </div>
          </div>
        </div>
        {
          (this.state.pic !== this.props.auth.uic) && (
            (this.props.my.personality.type16) ? (
              this._renderRelation()
            ): (
              <div align='center' style={{margin:'15px'}}>
                <div>あなたも性格診断をすると相性診断が表示されます</div>
                <Link to={'/my/personality/'}>
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{fontSize:'1.1em'}}
                  >
                    性格診断をする
                  </Button>
                </Link>
              </div>
            )
          )
        }
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
    auth: state.auth,
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
